export class PurchaseListModel {
  id: string;
  number: string;
  type: string;
  agent: string;
}

export class getPurchaseListInput {
  id: string;
  params: {
    page: number;
    limit?: number;
    q?: string;
  };
}
